var _path, _g, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _path5, _path6, _rect5, _rect6, _rect7, _rect8, _path7, _path8, _path9, _path0, _g2, _rect9, _rect0, _rect1, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadApplicationIllu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 202,
    viewBox: "0 0 215 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M212.828 68.0869C222.738 122.896 183.471 177.67 125.122 190.428C66.7737 203.186 11.4389 169.097 1.52877 114.288C-8.38137 59.4788 66.7737 29.0667 125.122 16.3087C183.471 3.55067 202.918 13.278 212.828 68.0869Z",
    fill: "#DFE8E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3600_1932)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0876,
    height: 23.6151,
    rx: 6.03127,
    transform: "matrix(0.948568 0.318754 -0.309924 0.950003 157.117 18.9769)",
    fill: "#FFF6CC",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.69 36.7126C168.022 36.824 168.383 36.6462 168.497 36.3155C168.612 35.9848 168.436 35.6264 168.104 35.515C167.772 35.4036 167.411 35.5814 167.297 35.9121C167.182 36.2429 167.358 36.6013 167.69 36.7126Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.72 34.0391C161.606 34.3698 161.244 34.5476 160.913 34.4362C160.581 34.3249 160.405 33.9665 160.519 33.6357C160.634 33.305 160.995 33.1272 161.327 33.2386C161.659 33.35 161.835 33.7084 161.72 34.0391Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.764 26.9455C162.991 26.6876 162.135 26.9014 161.57 27.4933L159.439 29.7279L158.448 29.3971C158.193 29.3121 157.916 29.4492 157.828 29.7034C157.741 29.9575 157.877 30.2325 158.132 30.3175L158.697 30.5062L158.55 30.66C158.341 30.8796 158.182 31.1414 158.083 31.4274L156.374 36.4018C156.143 37.0747 156.503 37.8027 157.177 38.0278L158.698 38.5352C158.953 38.6203 159.23 38.4832 159.317 38.229L160.071 36.0355L167.511 38.5182L166.757 40.7117C166.715 40.8337 166.723 40.967 166.78 41.0822C166.837 41.1974 166.938 41.285 167.06 41.3259L168.581 41.8332C169.255 42.0584 169.99 41.6954 170.221 41.0225L171.93 36.0482C172.028 35.7621 172.063 35.4588 172.032 35.159L172.011 34.9491L172.576 35.1378C172.831 35.2228 173.108 35.0857 173.196 34.8315C173.283 34.5774 173.147 34.3024 172.892 34.2174L171.901 33.8865L171.586 30.8357C171.502 30.0275 170.954 29.3448 170.181 29.0869L163.764 26.9455ZM157.79 35.2744L159.148 35.7275L158.553 37.4609L157.493 37.1074C157.328 37.0524 157.241 36.8743 157.297 36.7097L157.79 35.2744ZM170.108 38.3589L158.106 34.354L159.006 31.7354C159.059 31.5825 159.144 31.4426 159.256 31.3253L159.981 30.5649L160.662 31.6809C160.916 32.0963 161.309 32.409 161.772 32.5646L168.357 34.7765C168.82 34.9321 169.325 34.9208 169.783 34.7445L170.961 34.2913L171.062 35.2651C171.078 35.4253 171.06 35.5874 171.007 35.7402L170.108 38.3589ZM170.858 33.2929L170.615 30.9418C170.571 30.5099 170.278 30.1451 169.865 30.0073L163.448 27.8659C163.035 27.7281 162.577 27.8424 162.275 28.1587L160.679 29.8328L161.497 31.1726C161.633 31.3945 161.842 31.5616 162.09 31.6448L168.675 33.8567C168.923 33.9399 169.192 33.9338 169.437 33.8396L170.858 33.2929ZM168.433 38.8261L169.791 39.2793L169.298 40.7146C169.242 40.8791 169.062 40.9679 168.897 40.9128L167.838 40.5594L168.433 38.8261Z",
    fill: "#0D0D0D"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.205 69.0907C186.492 70.569 182.476 73.366 180.011 76.6126C180.443 71.8835 178.794 67.5715 175.446 64.2361C179.863 65.081 184.66 60.917 186.82 57.4518C185.818 61.2456 187.544 66.1036 190.205 69.0907Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.2814,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9864 150.288C42.281 153.23 39.8732 157.491 39.0591 161.485C37.3989 157.035 34.0445 153.864 29.5818 152.309C33.928 151.156 36.4471 145.325 36.8927 141.266C37.6329 145.119 41.294 148.749 44.9864 150.288Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.2814,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.365 167.993L64.0115 160.656L63.0391 154.62H107.144C105.939 159.487 105.244 174.806 107.201 178.774C104.749 175.025 104.365 171.924 104.365 167.993Z",
    fill: "#CFDADA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43.8841,
    y: 94.2984,
    width: 36.6469,
    height: 17.5042,
    rx: 8.7521,
    transform: "rotate(-44.5643 43.8841 94.2984)",
    fill: "#DFE8E8",
    stroke: "white",
    strokeWidth: 0.954822
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47.0996,
    y: 43.728,
    width: 42.7172,
    height: 20.4842,
    rx: 10.2421,
    transform: "rotate(19.099 47.0996 43.728)",
    fill: "#DFE8E8",
    stroke: "white",
    strokeWidth: 0.954822
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48.7162,
    y: 114.954,
    width: 34.8746,
    height: 16.6342,
    rx: 8.31708,
    transform: "rotate(-44.5643 48.7162 114.954)",
    fill: "#DFE8E8",
    stroke: "white",
    strokeWidth: 0.954822
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 53.0599,
    y: 131.24,
    width: 34.8746,
    height: 16.6342,
    rx: 8.31708,
    transform: "rotate(-44.5643 53.0599 131.24)",
    fill: "#DFE8E8",
    stroke: "white",
    strokeWidth: 0.954822
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.022 3.82347C145.77 3.79721 149.64 7.62497 149.667 12.373L150.386 142.404C150.412 147.153 146.585 151.023 141.837 151.049L74.1205 151.424C69.3725 151.45 65.5021 147.622 65.4759 142.874L64.7564 12.8428C64.7302 8.09476 68.5579 4.2244 73.306 4.19813L141.022 3.82347Z",
    fill: "#DFE8E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.004 0.599521C147.533 0.5634 152.854 5.82658 152.891 12.3552L153.61 142.387C153.646 148.915 148.383 154.237 141.854 154.273L74.1384 154.648C67.6098 154.684 62.288 149.421 62.2519 142.892L61.5325 12.8606C61.4964 6.33205 66.7595 1.0103 73.2881 0.974175L141.004 0.599521ZM146.443 12.3908C146.426 9.42329 144.007 7.03094 141.04 7.04736L73.3238 7.42201C70.3563 7.43843 67.9639 9.85741 67.9803 12.8249L68.6998 142.856C68.7162 145.824 71.1351 148.216 74.1027 148.2L141.819 147.825C144.786 147.809 147.179 145.39 147.162 142.422L146.443 12.3908Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 76.1553,
    y: 29.7072,
    width: 61.6458,
    height: 4.32602,
    rx: 2.16301,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 76.1553,
    y: 39.801,
    width: 61.6458,
    height: 4.32602,
    rx: 2.16301,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 76.1514,
    y: 89.9116,
    width: 62.7273,
    height: 21.9906,
    rx: 3.60502,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 76.1514,
    y: 116.228,
    width: 62.7273,
    height: 21.9906,
    rx: 3.60502,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M146.667 94.0092C146.667 103.939 146.234 103.629 135.853 116.248C126.256 127.96 120.991 145.597 118.285 154.866H74.4326L76.3973 166.936C77.0746 171.096 78.5399 175.089 80.7144 178.701L81.074 179.298C83.9449 184.065 85.4619 189.525 85.4619 195.091L87.7103 196.012C94.8215 198.926 102.372 200.622 110.047 201.03L114.61 201.273C124.214 201.273 133.726 199.414 142.623 195.799L143.098 195.606V190.102C143.098 183.895 157.48 171.793 164.293 158.76C169.005 149.745 167.266 99.8158 165.241 66.25C164.847 59.7262 157.629 56.0588 152.081 59.5129L147.253 62.5186C147.253 69.6902 146.667 86.0653 146.667 94.0092Z",
    fill: "#DFE8E8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.848 161.76C115.992 159.036 116.747 160.136 118.285 154.866M118.285 154.866C120.991 145.597 126.256 127.96 135.853 116.248C146.234 103.629 146.667 103.939 146.667 94.0092C146.667 86.0653 147.253 69.6902 147.253 62.5186L152.081 59.5129C157.629 56.0588 164.847 59.7262 165.241 66.25C167.266 99.8158 169.005 149.745 164.293 158.76C157.48 171.793 143.098 183.895 143.098 190.102C143.098 195.066 143.098 193.951 143.098 195.606L142.623 195.799C133.726 199.414 124.214 201.273 114.61 201.273V201.273L110.047 201.03C102.372 200.622 94.8215 198.926 87.7103 196.012L85.4619 195.091V195.091C85.4619 189.525 83.9449 184.065 81.074 179.298L80.7144 178.701C78.5399 175.089 77.0746 171.096 76.3973 166.936L74.4326 154.866H118.285Z",
    stroke: "white",
    strokeWidth: 0.954822
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.086 114.063C61.8877 111.823 59.875 108.253 58.4922 105.985C58.4922 105.985 61.76 102.806 61.9402 102.626C62.1164 102.45 61.9585 106.217 62.086 114.063C62.1031 114.257 62.1067 114.44 62.0953 114.612C62.092 114.427 62.0889 114.244 62.086 114.063Z",
    fill: "#CFDADA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0839 134.932C61.8861 132.663 60.0022 128.961 58.627 126.706L62.0938 123.106C62.0938 123.106 61.9565 127.101 62.0839 134.932C62.1021 135.141 62.106 135.339 62.0938 135.521C62.0903 135.323 62.087 135.126 62.0839 134.932Z",
    fill: "#CFDADA"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_3600_1932)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.0137,
    y: 54.2209,
    width: 87.2414,
    height: 28.1191,
    rx: 3.60502,
    fill: "white"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 70.9688,
    y: 61.267,
    width: 42.5392,
    height: 2.88401,
    rx: 1.44201,
    fill: "#DFE8E8"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 70.9688,
    y: 67.9197,
    width: 28.4796,
    height: 2.88401,
    rx: 1.44201,
    fill: "#DFE8E8"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 70.9688,
    y: 72.9332,
    width: 19.8276,
    height: 2.88401,
    rx: 1.44201,
    fill: "#DFE8E8"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_3600_1932)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.0078,
    height: 24.5172,
    rx: 6.26168,
    transform: "matrix(0.958526 -0.287425 0.295463 0.954599 33.9053 58.611)",
    fill: "#FFF6CC",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3600_1932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.7907 64.0323C52.9467 63.7452 52.8426 63.3868 52.5583 63.2318C52.2739 63.0768 51.9169 63.1839 51.7609 63.471L49.1899 68.2024L47.1041 67.0656C46.8197 66.9107 46.4627 67.0178 46.3067 67.3049C46.1507 67.592 46.2548 67.9504 46.5392 68.1053L49.6548 69.8034L52.7907 64.0323Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8902 64.5649C58.0789 68.6586 55.7368 72.9689 51.6589 74.1923C47.5811 75.4156 43.3117 73.0888 42.123 68.9951C40.9343 64.9014 43.2765 60.5911 47.3543 59.3677C51.4322 58.1444 55.7015 60.4712 56.8902 64.5649ZM55.7625 64.9032C56.7697 68.3717 54.7853 72.0237 51.3302 73.0602C47.8752 74.0967 44.2578 72.1252 43.2507 68.6568C42.2436 65.1883 44.228 61.5363 47.683 60.4998C51.1381 59.4633 54.7554 61.4348 55.7625 64.9032Z",
    fill: "#0D0D0D"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_3600_1932)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.5195,
    height: 32.862,
    rx: 8.39293,
    transform: "matrix(0.984791 0.177687 -0.168743 0.984928 143.039 141.93)",
    fill: "#FFF6CC",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.305 168.022C147.724 168.541 148.32 168.888 148.98 168.997L160.576 171.088C161.161 171.199 161.77 171.095 162.289 170.796C162.809 170.496 163.206 170.019 163.404 169.453L165.97 162.175C166.09 161.835 166.134 161.474 166.099 161.117C166.065 160.759 165.953 160.414 165.772 160.105C165.59 159.797 165.343 159.532 165.048 159.329C164.754 159.127 164.419 158.991 164.066 158.931L160.138 158.222L160.621 155.672C160.785 154.804 160.598 153.91 160.101 153.186C159.603 152.462 158.836 151.967 157.968 151.811C157.661 151.755 157.349 151.886 157.171 152.144L152.718 158.605L151.007 158.296C150.351 158.168 149.667 158.284 149.086 158.622C148.503 158.962 148.063 159.503 147.851 160.142C147.839 160.176 147.83 160.21 147.824 160.245L146.721 166.067C146.714 166.101 146.71 166.137 146.708 166.172C146.673 166.843 146.885 167.501 147.305 168.022ZM149.254 167.441C148.972 167.395 148.718 167.248 148.54 167.027C148.371 166.818 148.282 166.556 148.285 166.288L149.366 160.584C149.461 160.332 149.64 160.119 149.875 159.983C150.122 159.838 150.413 159.789 150.693 159.845L152.152 160.108L150.713 167.704L149.268 167.443L149.254 167.441ZM158.136 153.516L153.821 159.777L152.266 167.984L160.883 169.537C161.096 169.578 161.318 169.541 161.507 169.432C161.697 169.323 161.841 169.149 161.913 168.943L164.479 161.665C164.522 161.542 164.538 161.41 164.526 161.28C164.514 161.151 164.473 161.025 164.407 160.913C164.341 160.801 164.251 160.704 164.144 160.63C164.036 160.557 163.914 160.507 163.785 160.485L163.776 160.484L159.067 159.635C158.638 159.557 158.356 159.147 158.438 158.719L159.068 155.392C159.154 154.936 159.056 154.466 158.795 154.086C158.626 153.841 158.399 153.645 158.136 153.516Z",
    fill: "#0D0D0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3600_1932",
    x: 144.663,
    y: 15.7674,
    width: 40.4384,
    height: 40.3829,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.60476
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3600_1932"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.92571
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.56762
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3600_1932",
    result: "effect2_dropShadow_3600_1932"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3600_1932",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_3600_1932",
    x: 39.2456,
    y: 50.6159,
    width: 98.7773,
    height: 39.6552,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.80251
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3600_1932"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.16301
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.88401
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3600_1932",
    result: "effect2_dropShadow_3600_1932"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3600_1932",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_3600_1932",
    x: 28.5739,
    y: 48.091,
    width: 41.8777,
    height: 41.2548,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66607
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3600_1932"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.99928
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66571
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3600_1932",
    result: "effect2_dropShadow_3600_1932"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3600_1932",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_3600_1932",
    x: 130.348,
    y: 137.464,
    width: 52.8468,
    height: 52.6148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.23314
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3600_1932"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.67976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.57302
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3600_1932",
    result: "effect2_dropShadow_3600_1932"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3600_1932",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3600_1932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.1958,
    height: 20.1958,
    fill: "white",
    transform: "matrix(0.957209 -0.287164 0.279026 0.960925 37.0234 59.9764)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadApplicationIllu);
export default __webpack_public_path__ + "static/media/DownloadApplicationIllu.8aaaf668170b62a04cfd53c0c41efba0.svg";
export { ForwardRef as ReactComponent };